// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CuponesGanadores_container__r-w\\+F {
  animation: CuponesGanadores_init__QNhqm 0.5s both;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/*---Title---*/
.CuponesGanadores_container__r-w\\+F .CuponesGanadores_titleContainer__HwlLq {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_titleContainer__HwlLq h4 {
  margin-left: 10px;
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_titleContainer__HwlLq .CuponesGanadores_arrow__N8qjn {
  transition: 0.3s;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_titleContainer__HwlLq .CuponesGanadores_arrow__N8qjn:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR {
  animation: CuponesGanadores_init3__DS339 0.5s both 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_barcode__6g4L9 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_barcode__6g4L9 form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_barcode__6g4L9 form input {
  width: 100%;
  border: 1px solid rgba(128, 128, 128, 0.407);
  background-color: transparent;
  border-radius: 3px;
  padding-left: 10px;
  font-size: 1.2rem;
  height: 47px;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_barcode__6g4L9 form input:focus {
  background-color: white;
  border: 1px solid gray;
  outline: none;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_barcode__6g4L9 form input:hover {
  border: 1px solid gray;
  outline: none;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR .CuponesGanadores_send__ZXz5b {
  animation: CuponesGanadores_init2__kmuSz 0.5s both 1s;
  width: 90%;
  height: 3.5rem;
}

.CuponesGanadores_container__r-w\\+F .CuponesGanadores_form__xn6lR p {
  font-size: 1rem;
  font-weight: 300;
  margin: 0;
  margin-top: 20px;
  margin-bottom: 10px;
}

@keyframes CuponesGanadores_init__QNhqm {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes CuponesGanadores_init2__kmuSz {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes CuponesGanadores_init3__DS339 {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/CuponesGanadores/CuponesGanadores.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uDAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qDAA6B;EAC7B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  margin-left: 10px;\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .form {\n  animation: init3 0.5s both 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .barcode {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .form .barcode form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n}\n\n.container .form .barcode form input {\n  width: 100%;\n  border: 1px solid rgba(128, 128, 128, 0.407);\n  background-color: transparent;\n  border-radius: 3px;\n  padding-left: 10px;\n  font-size: 1.2rem;\n  height: 47px;\n}\n\n.container .form .barcode form input:focus {\n  background-color: white;\n  border: 1px solid gray;\n  outline: none;\n}\n\n.container .form .barcode form input:hover {\n  border: 1px solid gray;\n  outline: none;\n}\n\n.container .form .send {\n  animation: init2 0.5s both 1s;\n  width: 90%;\n  height: 3.5rem;\n}\n\n.container .form p {\n  font-size: 1rem;\n  font-weight: 300;\n  margin: 0;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CuponesGanadores_container__r-w+F`,
	"init": `CuponesGanadores_init__QNhqm`,
	"titleContainer": `CuponesGanadores_titleContainer__HwlLq`,
	"arrow": `CuponesGanadores_arrow__N8qjn`,
	"form": `CuponesGanadores_form__xn6lR`,
	"init3": `CuponesGanadores_init3__DS339`,
	"barcode": `CuponesGanadores_barcode__6g4L9`,
	"send": `CuponesGanadores_send__ZXz5b`,
	"init2": `CuponesGanadores_init2__kmuSz`
};
export default ___CSS_LOADER_EXPORT___;
